module.exports = __webpack_public_path__ + "img/s23.8e983aa4.png";